import { render, staticRenderFns } from "./SupplierTotalOutstandingNumberDisplayer.vue?vue&type=template&id=8794f3ae"
import script from "./SupplierTotalOutstandingNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SupplierTotalOutstandingNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports